import { render, staticRenderFns } from "./class-builder.view.vue?vue&type=template&id=5795bb10&scoped=true&"
import script from "./class-builder.view.ts?vue&type=script&lang=ts&"
export * from "./class-builder.view.ts?vue&type=script&lang=ts&"
import style0 from "./class-builder.view.scss?vue&type=style&index=0&id=5795bb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795bb10",
  null
  
)

export default component.exports